var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      style: { width: _vm.width },
      attrs: {
        value: _vm.value,
        placeholder: _vm.placeholder,
        clearable: _vm.clearable,
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        "remote-method": _vm.handleSearch,
        loading: _vm.loading,
      },
      on: { change: _vm.handleChange, clear: _vm.handleClear },
    },
    _vm._l(_vm.options, function (item) {
      return _c(
        "el-option",
        {
          key: item.userId,
          attrs: {
            label: item.mobilePhone + " / " + (item.alias || "-"),
            value: item.userId,
          },
        },
        [
          _c(
            "div",
            { staticClass: "phone-user-option" },
            [
              _vm.getAvatarUrl(item.userpic)
                ? _c("el-avatar", {
                    attrs: { src: _vm.getAvatarUrl(item.userpic), size: 26 },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "opt-mobile" }, [
                _vm._v(_vm._s(item.mobilePhone)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "opt-alias" }, [
                _vm._v(_vm._s(item.alias || "-")),
              ]),
            ],
            1
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }